import React from 'react';
import { Type } from '../../../../../general/modules/filter/dataModel';

import { Column, FMColumn } from '../../model';

import { FileManagerRow } from '../../model';

import { useCollapse } from '../context';

import './styles.scss';

export const PersonCellInner: React.FC<{
  rowData: FileManagerRow;
  column: FMColumn<Type.STRING>;
}> = ({ rowData, column }) => {
  const collapse = useCollapse();

  const full_name = column.getter?.(rowData);
  const email: string =
    (column.key === Column.manager
      ? rowData.creative?.customer?.email
      : rowData.creative?.executor?.email) ?? '<no email>';
  if (full_name === null) {
    return <span></span>;
  }

  if (collapse) {
    const [n, sn] = full_name.split(' ');
    const short_name = `${n.substr(0, 1)}. ${sn}`;
    return <span title={`${full_name} (${email})`}>{short_name}</span>;
  }
  return <span title={`${email}`}>{full_name}</span>;
};

export const PersonCell = (props: any) => <PersonCellInner {...props} />;
